import { TextField } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { Dialog } from "@/components/Dialog/Dialog";

interface OTPPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (otp: string) => void;
  error?: string;
}

export const OTPPopup = ({
  isOpen,
  onClose,
  onSubmit,
  error,
}: OTPPopupProps) => {
  const intl = useIntl();
  const [otp, setOtp] = useState("");

  const handleSubmit = () => {
    onSubmit(otp);
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage({
        id: "payment.otp.title",
        defaultMessage: "OTP verification",
      })}
    >
      <div className="flex flex-col gap-4 pt-4">
        <TextField
          variant="outlined"
          fullWidth
          label={intl.formatMessage({
            id: "payment.otp.inputLabel",
            defaultMessage: "OTP",
          })}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { inputMode: "numeric", pattern: "d*" },
          }}
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          placeholder={intl.formatMessage({
            id: "payment.otp.inputPlaceholder",
            defaultMessage: "Enter OTP code",
          })}
          error={!!error}
          helperText={error}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={!otp}
        >
          {intl.formatMessage({
            id: "payment.otp.submitLabel",
            defaultMessage: "Verify",
          })}
        </Button>
      </div>
    </Dialog>
  );
};
